"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createCardSummaryDocument(cardId, data) {
    var doc = {
        card: cardId,
        content: JSON.stringify(data.summary),
    };
    return doc;
}
exports.default = createCardSummaryDocument;
//# sourceMappingURL=createCardSummaryDocument.js.map